import { enc, AES, mode, pad } from 'crypto-js';
import { isObject } from 'lodash-es';

import { SECRET_IV, SECRET_KEY } from './secret';

/**
 * AES 加密
 * @param data
 * @returns
 */
const encrypt = (data: object | string): string => {
	if (isObject(data)) {
		try {
			data = JSON.stringify(data);
		} catch (e) {
			throw new Error('encrypt error' + e);
		}
	}

	const dataHex = enc.Utf8.parse(data);
	const encrypted = AES.encrypt(dataHex, SECRET_KEY, {
		iv: SECRET_IV,
		mode: mode.CBC,
		padding: pad.Pkcs7,
	});

	return encrypted.ciphertext.toString();
};

/**
 * AES 解密
 * @param data
 * @returns
 */
const decrypt = (data: string) => {
	//解密
	const encryptedHexStr = enc.Hex.parse(data);
	const str = enc.Base64.stringify(encryptedHexStr);

	const decrypt = AES.decrypt(str, SECRET_KEY, {
		iv: SECRET_IV,
		mode: mode.CBC,
		padding: pad.Pkcs7,
	});

	const decryptedStr = decrypt.toString(enc.Utf8);

	return decryptedStr.toString();
};

const aesCrypto = {
	encrypt,
	decrypt,
};

export default aesCrypto;
